import {configureStore} from "@reduxjs/toolkit";
import themeReducer from "@/features/Theme/theme-slice";
import sidebarSlice from "@/features/Sidebar/sidebar-slice";
import dataSlice from "@/features/Data/data-slice";
import breadCrumbSlice from "@/features/BreadCrumb/bread-crumb-slice";
import confirmDialogSlice from "@/features/ConfirmDialog/confirm-dialog-slice";
import localeSlice from "@/features/Locales/locale-slice";

export const store = configureStore({
    reducer: {
        theme: themeReducer,
        sidebar: sidebarSlice,
        data: dataSlice,
        breadCrumb: breadCrumbSlice,
        confirmDialog: confirmDialogSlice,
        locale: localeSlice,
    }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;